import Axios from "axios";
import { axiosClient } from "../client";

const INTEGRATIONS_PER_LOCATION = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/integrations`;

const INTEGRATIONS_CONFIG = (locationId) =>
  `${process.env.REACT_APP_API_PRESTO_EXPRESS_SALES}/v1/location/${locationId}/hubrise`;


// export const createLocationsInfo = (data) =>
//   axiosClient({
//     url: LOCATIONS_INFO_CREATE,
//     method: "POST",
//     data,
//   });


export const getIntegrationsPerLocation = (locationId) =>
  axiosClient({
    url: INTEGRATIONS_PER_LOCATION(locationId),
    method: "GET",
  });

  export const getIntegrationConfig = (locationId) =>
  axiosClient({
    url: INTEGRATIONS_CONFIG(locationId),
    method: "GET",
  });

  